<template>
    <div>
        <img src="img/banner-1.jpg" class="nark">
        <sub-navigation :data='Englishnavigation'></sub-navigation>
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import SubNavigation from '@/components/pc/SubNavigation'
export default {
    components:{
      SubNavigation
    } ,
    computed:{
        ...mapState({
            Englishnavigation:state=>state.share.Englishnavigation
        })
    },
}
</script>

<style>

</style>